import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function QRRedirect() {
  const { shortcode } = useParams();
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`/api/qr?shortcode=${encodeURIComponent(shortcode)}`)
      .then(res => {
        if (!res.ok) throw new Error('not found');
        return res.json();
      })
      .then(data => {
        if (data.destination_url) {
          window.location.replace(data.destination_url);
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true));
  }, [shortcode]);

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
        <p>QR-Code nicht gefunden.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <p>Weiterleitung...</p>
    </div>
  );
}
